<template>
	<section class="wrapper-container scroll-color">
		<section v-if="customers.length > 0">
			<customer-wrapper
				v-for="customer in customers"
				:key="customer.id_customer"
				:customer="customer"
				:checked="customer.checked"
				v-model="customerSelected"
			/>
		</section>
		<section class="not-found" v-else>
			<div>Nenhum cliente foi encontrado.</div>
		</section>
	</section>
</template>

<script>
	import CustomerWrapper from './components/customer-wrapper'

	export default {
		name: 'ui-customer-wrapper-list',

		components: {
			CustomerWrapper,
		},

		props: {
			value: {
				type: Array,
				default: () => [],
			},
		},

		data() {
			return {
				customers: [],
				customerSelected: -1,
			}
		},

		watch: {
			value(value) {
				this.customerSelected = -1
				this.customers = value
			},

			customerSelected: {
				handler(value) {
					this.customers.map((customer) => {
						if (customer.id_customer == value) {
							customer.checked = true
							return
						}

						customer.checked = false
					})
				},

				deep: true,
			},

			customers: {
				handler(value) {
					this.$emit('input', value)
				},

				deep: true,
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
